import type { SearchPanelGroup } from './types';

// Generic local filter used in uncontrolled mode. An empty query shows all
// groups (the panel lists everything by default). A group match (label or a
// string secondaryLabel) keeps all its items; otherwise only items whose label
// matches are kept, and empty groups are dropped. Domain-specific matching
// (custom fields, "N of M" meta, server search) is done by the consumer in
// controlled mode instead.
export const filterGroups = (
  groups: SearchPanelGroup[],
  query: string,
): SearchPanelGroup[] => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return groups;

  const matches = (text: unknown) =>
    typeof text === 'string' && text.toLowerCase().includes(normalized);

  return groups.flatMap((group) => {
    if (matches(group.label) || matches(group.secondaryLabel)) return [group];

    const items = group.items.filter((item) => matches(item.label));
    if (items.length === 0) return [];

    return [{ ...group, items }];
  });
};
